/**
 * @param formData {FormData}
 * @return {{[field: string]: string}}
 */
module.exports = function convertFormDataToJson(formData) {
    const entries = formData.entries();

    const formDataJson = {};
    for (let [key, value] of entries) {
        formDataJson[key] = value;
    }

    return formDataJson;
}